<template>
  <fieldset class="budget-fieldset">
    <legend>Budget*</legend>
	<div class="col-md-2">

	</div>
    <div class="col-md-10">
      With the above settings, this boost will cost <span style="font-weight: bold;">USD 0.00</span>
    </div>
    <div class="text-right">
      <a
        style="color: white"
        class="clickable delete-link"
        @click="onClickDelete"
        >CANCEL {{typeBudget}}</a
      >
    </div>

    <v-dialog v-model="openDeleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          CANCEL {{typeBudget}}
        </v-card-title>

        <v-card-text>
          <h5 style="margin: 1rem 0">
            Are you sure for cancel {{ contentName }}?
          </h5>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="onAgreeDelete"> Yes </v-btn>
          <v-btn color="red" text @click="openDeleteDialog = false"> No </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </fieldset>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    contentName: {
      type: String,
      default: "experience",
    },
    typeBudget : String
  },
  data() {
    return {
      openDeleteDialog: false,
    };
  },
  mounted() {
    this.checked = this.value;
  },
  methods: {
    onChange(ev) {
      this.$emit("input", ev.target.checked);
    },
    onClickDelete() {
      this.openDeleteDialog = true;
    },
    onAgreeDelete() {
      this.$emit("delete");
    },
  },
};
</script>

<style lang="scss">
.budget-fieldset {

  .delete-link {
    text-transform: uppercase;
    text-decoration: underline;
    font-style: italic;
    font-size: 0.9rem;
    letter-spacing: 1.25px;
  }
}
</style>
